import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar2--sprite",
  "use": "calendar2--sprite-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol viewBox=\"0 0 10 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"calendar2--sprite\">\n<path d=\"M9 1.5H8.5V0.5H7.5V1.5H2.5V0.5H1.5V1.5H1C0.45 1.5 0 1.95 0 2.5V10.5C0 11.05 0.45 11.5 1 11.5H9C9.55 11.5 10 11.05 10 10.5V2.5C10 1.95 9.55 1.5 9 1.5ZM9 10.5H1V4H9V10.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol